import { render, staticRenderFns } from "./ViewFlashContent.vue?vue&type=template&id=b96b7d24&"
import script from "./ViewFlashContent.vue?vue&type=script&lang=js&"
export * from "./ViewFlashContent.vue?vue&type=script&lang=js&"
import style0 from "./ViewFlashContent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports